<template>
  <div>
    <div class="text-center">
      <h1>Service Report</h1>
    </div>
    <MonthDetail :usedMonth="currentMonth" />
  </div>
</template>

<script>
import MonthDetail from "../components/month/MonthDetail.vue";
import moment from "moment";

export default {
  components: {
    MonthDetail,
  },
  data() {
    return {
      events: [],
    };
  },
  computed: {
    currentMonth() {
      return moment().format("YYYY-MM");
    },
  },
};
</script>
